import { CheckCircleIcon2, ClockIcon } from "@/styles/icons";
import { CloseIcon } from "@/styles/icons/CloseIcon";
import { Modal } from "barte-design-system";

type StatusType = "success" | "pending" | "error";

interface StatusModalProps {
  isOpen: boolean;
  onClose: () => void;
  status: StatusType;
  message: string;
  title?: string;
}

const statusIcons: Record<StatusType, React.ElementType> = {
  success: CheckCircleIcon2,
  pending: ClockIcon,
  error: CloseIcon,
};

const defaultTitles: Record<StatusType, string> = {
  success: "Sucesso",
  pending: "Pendente",
  error: "Erro",
};

export function StatusModal({
  isOpen,
  onClose,
  status,
  message,
  title,
}: StatusModalProps) {
  const IconComponent = statusIcons[status];

  return (
    <Modal
      isOpen={isOpen}
      title={title ?? defaultTitles[status]}
      onClose={onClose}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          paddingBottom: "2rem",
          gap: "1rem",
        }}
      >
        <IconComponent />
        <p style={{ fontSize: "1.125rem", textAlign: "center" }}>{message}</p>
      </div>
    </Modal>
  );
}
